<script>
    import Background from "./Background.svelte";
    import OverlayCloseButton from "./OverlayCloseButton.svelte";

    // whether this overlay should be shown
    export let show = true;

    // by default, show a random background image from the set
    export let background = "random";
    //export let loaderBackground;
    let loaderBackground = "#fff";

    // whether this overlay is app-wide (true) or local to a specific element
    export let global = true;

    // whether this overlay is modal or not
    export let closable = false;

    export let style = "";

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    let height;

    $: useBackground = ![0, false, "false", "none"].includes(background);

    // notify parent that we are leaving and hide
    const close = () => {
        dispatch("close")
        show = false;
        return false;
    };

    // if this overlay is closable we should be able to click outside of the dialog to close
    function handleClick(evt) {
        if (closable) {
            return close();
        }
    }

    function handleEsc(evt) {
        if (!evt) {
            // NoOp
        }
        else if (evt.key && evt.key == "Escape") {
            return close();
        }
        else if (evt.keyCode && evt.keyCode == 27) {
            return close();
        }
    }

    $: isOffscreen = height && height > window.innerHeight;

</script>

<svelte:window on:keydown={handleEsc}/>

<div {style} class:show class:global class:closable class:isOffscreen class="app-overlay" on:click|self={handleClick}>
    <Background enable={useBackground} content={background} {loaderBackground} loader={global} width={1900}/>
    <span bind:clientHeight={height}>
        <slot >
            <!-- subcomponents will yield here -->
        </slot>
    </span>

    <OverlayCloseButton
            show={closable}
            {global}
            on:click={close}
            contrast={!useBackground}
    />
</div>

<style>
    .app-overlay {
        z-index: 7;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 1;
        transition: all 0.5s;

        /* local */
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        width: 100%;
        height: 100%;
    }

    .app-overlay.isOffscreen {
        align-items: start;
    }

    :global(.app-overlay.isOffscreen .dialog) {
        margin: 100px 0;
    }

    .app-overlay.global {
        position: fixed;
        width: 100vw;
        height: 100vh;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    :global(.app-overlay.global > .background) {
        position: fixed;
        width: 100vw;
        height: 100vh;
    }

    .app-overlay:not(.show) {
        opacity: 0;
        pointer-events: none;
    }

</style>